import { render, staticRenderFns } from "./ErrorIcon.vue?vue&type=template&id=7d4b05a4&scoped=true&"
import script from "./ErrorIcon.vue?vue&type=script&lang=ts&"
export * from "./ErrorIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorIcon.vue?vue&type=style&index=0&id=7d4b05a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4b05a4",
  null
  
)

export default component.exports